import { render, staticRenderFns } from "./SendMessageToRecipient.vue?vue&type=template&id=03e18255"
import script from "./SendMessageToRecipient.vue?vue&type=script&lang=js"
export * from "./SendMessageToRecipient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports